import { TUsState } from '../types';

export const transformUsStates = (states: string[]): TUsState[] => {
  return states.map(state => ({
    id: state,
    label: state,
    value: state,
  }));
};
